export const KpiVI = {
    "kpi": "Danh sách đánh giá",
    "kpiPeriod":"Kỳ đánh giá",
    "kpiList":"Danh sách đánh giá",
    "kpiTemplate":"Mẫu đánh giá",
    "kpiCriteria":"Tiêu chí đánh giá"
}